export default __webpack_public_path__ + "static/media/sub-category-eventsAndVenues-outdoorEvents.9eaf8e04.jpg";